import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import { DatalistField, FormSelectField, FormTextField } from "./FormComponents";
import { STATES_OPTIONS } from "../../../../../constants";

const ClinicFormComponent = ({ clinic, handleValueChange, updateResource }) => {
  const clinics = useSelector(({ app: { clinics } }) => clinics);
  const [clinicOptions, setClinicOptions] = useState([]);

  const resetResource = () =>
    updateResource({
      id: "",
      name: "",
      address: {
        street: "",
        suburb: "",
        postcode: "",
      },
      email: "",
      phone: "",
      fax: "",
    });

  const onClinicSelected = (selectedItem) => {
    const id = clinics.find(({ name }) => selectedItem?.toLowerCase() === name?.toLowerCase())?.id;

    if (_.isEmpty(id)) {
      resetResource();
    }

    const selectedClinic = clinics.filter(({ id: clinicId }) => clinicId === id)[0];

    if (!_.isEmpty(selectedClinic)) {
      updateResource({
        id,
        name: selectedClinic.name,
        address: {
          street: selectedClinic.street,
          suburb: selectedClinic.suburb,
          postcode: selectedClinic.postCode,
          state: selectedClinic.state,
        },
        email: selectedClinic.email,
        phone: selectedClinic.phone,
        fax: selectedClinic.fax,
      });
    }
  };

  const handleAddressChange = (label) => (value) => {
    handleValueChange("address")({
      ...clinic.address,
      [label]: value,
    });
  };

  const handleClinicValueChange = (value) => {
    resetResource();
    const options = clinics.reduce((res, { name }) => {
      if (name.toLowerCase().includes(value.trim().toLowerCase())) {
        return [...res, name];
      }

      return [...res];
    }, []);

    setClinicOptions(options);
  };

  useEffect(() => {
    setClinicOptions(clinics.map(({ name }) => name));
  }, [clinics]);

  useEffect(() => {
    if (!_.isEmpty(clinics) && !_.isEmpty(clinic.name)) {
      onClinicSelected(clinic.name);
    }
    // eslint-disable-next-line
  }, [clinics]);

  return (
    <>
      <p className="menu-label">CLINIC</p>
      <div className="columns">
        <DatalistField
          defaultValue={clinic.name}
          id="clinic"
          className="column is-half"
          label="Clinic"
          options={clinicOptions}
          onSelect={onClinicSelected}
          onValueChange={handleClinicValueChange}
        />
      </div>
      <div className="columns">
        <FormTextField
          className="column is-full"
          required
          label="Clinic Name"
          value={clinic.name}
          onValueChange={handleValueChange("name")}
        />
      </div>
      <div className="columns">
        <FormTextField
          className="column"
          label="Street Address"
          value={clinic.address?.street || ""}
          onValueChange={handleAddressChange("street")}
        />
        <FormSelectField
          onValueChange={handleAddressChange("state")}
          options={STATES_OPTIONS}
          className="column"
          label="State"
          value={clinic.address?.state}
        />
      </div>
      <div className="columns">
        <FormTextField
          className="column is-half"
          label="Suburb"
          value={clinic.address?.suburb}
          onValueChange={handleAddressChange("suburb")}
        />
        <FormTextField
          className="column is-half"
          label="Postcode"
          value={clinic.address?.postcode}
          onValueChange={handleAddressChange("postcode")}
        />
      </div>
      <div className="columns">
        <FormTextField
          className="column is-half"
          label="Email"
          placeholder="eg. telecare@gmail.com"
          value={clinic.email}
          onValueChange={handleValueChange("email")}
        />
        <FormTextField
          className="column is-one-quarter"
          label="Work Number"
          placeholder="eg. 04312345678"
          value={clinic.phone}
          onValueChange={handleValueChange("phone")}
        />
        <FormTextField
          className="column is-one-quarter"
          label="Fax"
          value={clinic.fax}
          onValueChange={handleValueChange("fax")}
        />
      </div>
    </>
  );
};

export default ClinicFormComponent;
